<template>
  <div>
    <q-form @submit="this.onSubmit" class="form">
      <div class="form__item">
        <CustomInput
          label="Название"
          type="text"
          :required="true"
          :value="this.formData.work_set_check_group_name"
          @change_input="
            (value) => onChange('work_set_check_group_name', value)
          "
        />
      </div>

      <div class="form__item">
        <CustomInput
          label="Код группы"
          type="text"
          :required="true"
          :value="this.formData.work_set_check_group_code"
          @change_input="
            (value) => onChange('work_set_check_group_code', value)
          "
        />
      </div>

      <div class="form__item">
        <CustomInput
          label="Короткое название"
          type="text"
          :value="this.formData.work_set_check_group_short_name"
          @change_input="
            (value) => onChange('work_set_check_group_short_name', value)
          "
        />
      </div>

      <div class="form__item">
        <CustomInput
          label="Порядок*"
          type="number"
          :value="this.formData.order_num"
          aria-required="true"
          @change_input="(value) => onChange('order_num', value)"
        />
      </div>

      <div class="form__item">
        <CustomSelect
          :value="formData.stage_id"
          label="Этап работ"
          :options="stageOptions"
          option-label-key="label"
          option-value-key="stage_id"
          :required="true"
          :use-input="true"
          :clearable="true"
          @change="onChangeStage"
        />
      </div>

      <div class="form__item">
        <CustomInput
          label="Процент бригады"
          type="number"
          step="0.01"
          :value="this.formData.team_payment_part"
          @change_input="(value) => onChange('team_payment_part', value)"
        />
      </div>

      <div class="form__item">
        <CustomInput
          label="Процент подряда"
          type="number"
          step="0.01"
          :value="this.formData.payment_part"
          @change_input="(value) => onChange('payment_part', value)"
        />
      </div>

      <div class="form__item">
        <CustomSelect
          :value="formData.company_id"
          label="Компания"
          :options="companyOptions"
          option-label-key="company_name"
          option-value-key="company_id"
          :required="true"
          :use-input="true"
          :clearable="true"
          @change="onChangeCompany"
        />
      </div>

      <div></div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import { workSetCheckGroupsAPI } from "@/views/WorkSetCheckGroups/api";

export default {
  name: "add-work-set-check-groups",
  components: {
    CustomInput,
    CustomModalFooter,
    CustomSelect,
  },
  props: ["data"],
  data() {
    return {
      loading: false,
      companyOptions: [],
      stageOptions: [],
      formData: {
        work_set_check_group_name:
          this.data?.body?.work_set_check_group_name || "",
        work_set_check_group_code:
          this.data?.body?.work_set_check_group_code || "",
        work_set_check_group_short_name:
          this.data?.body?.work_set_check_group_short_name || "",
        order_num: this.data?.body?.order_num || "",
        stage_id: this.data?.body?.stage_id || "",
        payment_part: this.data?.body?.payment_part || "",
        team_payment_part: this.data?.body?.team_payment_part || "",
        company_id: this.data?.body?.company_id || "",
      },
    };
  },
  methods: {
    async fetchCompanyOptions() {
      try {
        const response = await workSetCheckGroupsAPI.getCompanies();

        if (response && response.data && Array.isArray(response.data)) {
          this.companyOptions = response.data;
        }
      } catch (e) {
        this.companyOptions = [];
        throw(e)
      }
    },

    async fetchStageOptions() {
      try {
        const response = await workSetCheckGroupsAPI.getStages();

        if (response && response.data && Array.isArray(response.data)) {
          this.stageOptions = response.data.map((stage) => ({
            stage_id: stage.stage_id,
            label: stage.stage_name,
          }));
        }
      } catch (e) {
        this.stageOptions = [];
      }
    },

    onChange(key, value) {
      this.formData[key] = value;
    },

    onChangeCompany(value) {
      this.formData.company_id = value;
    },

    onChangeStage(value) {
      this.formData.stage_id = value;
    },

    validateFormData() {
      const es = [];

      if (!this.formData.work_set_check_group_name) {
        es.push("Название группы обязательно");
      }

      if (!this.formData.work_set_check_group_code) {
        es.push("Код группы обязателен");
      }

      if (!this.formData.stage_id) {
        es.push("Этап работ обязателен");
      }

      if (!this.formData.company_id) {
        es.push("Компания обязательна");
      }

      return es;
    },

    cleanFormData() {
      const cleanedData = { ...this.formData };

      Object.keys(cleanedData).forEach((key) => {
        if (
          cleanedData[key] === "" ||
          cleanedData[key] === null ||
          cleanedData[key] === undefined
        ) {
          delete cleanedData[key];
        }
      });

      if (cleanedData.order_num) {
        cleanedData.order_num = parseInt(cleanedData.order_num);
      }

      if (cleanedData.payment_part) {
        cleanedData.payment_part = parseFloat(cleanedData.payment_part);
      }

      if (cleanedData.team_payment_part) {
        cleanedData.team_payment_part = parseFloat(
          cleanedData.team_payment_part
        );
      }

      return cleanedData;
    },

    async onSubmit() {
      this.loading = true;

      const cleanedData = this.cleanFormData();
      const startTime = Date.now();
      await this.data?.onSubmit(cleanedData);
      const endTime = Date.now();

      this.loading = false;
    },
  },

  async mounted() {
    await Promise.all([this.fetchCompanyOptions(), this.fetchStageOptions()]);
  },
};
</script>

<style scoped lang="scss">
.form {
  display: grid;
  flex-wrap: wrap;
  grid-template-columns: 6fr 6fr;
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 12fr;
  }

  .form__item {
    flex: 1 1 45%;
  }
}
</style>
